import { Component, OnInit } from '@angular/core';
import { EmployerService } from '../../../services/employer.service';
import { CommonSettings } from 'epay-library';

@Component({
  selector: 'epay-creditcard',
  templateUrl: './creditcard.payment.component.html'
})
export class EMPCreditCardPaymentComponent implements OnInit {
  pagetitle = 'Employer: Create Credit Card Payment';
  baseurl= '';
  clientName= '';
  termsContent= '';
  creditCardUrl= '';
  creditCardOriginKey= '';
  validateCaseNumber = false;
  allowZeroAmount = false;
  isMobile = false;
  creditCardVendorId = 0;
  creditCardDisclaimer = '';
  fortPointStateCode = '';

  constructor(private employerService: EmployerService) {
    this.baseurl = CommonSettings.BaseApi;
    this.clientName = CommonSettings.ClientName;
    this.validateCaseNumber = true;
    this.allowZeroAmount = false;
    this.creditCardVendorId = CommonSettings.CreditCardVendorID;
  }

  ngOnInit() {
    this.employerService.getEmployerTerms().subscribe(
      result => {
        this.termsContent = result;
      }
    );

  }
}
